import styled from 'styled-components';

const PeopleModalStyled = styled.div`
  width: 800px;
  .table-header {
    width: 100%;
  }
  .coupon-name-wrap {
    padding-right: 48px;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: flex-end;
  }
  .coupon-name {
    width: 261px;
    margin-left: 24px;
    /* float: right; */
  }
  .coupon-list {
    overflow-y: auto;
    width: 100%;
  }
  .modal-btn-wrap {
    display: flex;
    flex-direction: row;
    float: right;
    /* margin-bottom:35px; */
    gap: 6px;
    /* margin-top: ${(props) => props.theme.spacing(23 / 8)}; */
    margin-right: ${(props) => props.theme.spacing(3)};
    margin-bottom: ${(props) => props.theme.spacing(36 / 8)};
  }
`;

export default PeopleModalStyled;
